export default class RequestersFilter {
  constructor() {
    this.receivers_select = $('#position_contact_ids');
    this.options = this.receivers_select.find('option');
  }

  filter(cc_id) {
    let filtered_opts = this.options.filter((index, option) => {
      return $(option).data('company-id') === undefined || $(option).data('company-id') == cc_id;
    });
    this.receivers_select.html(filtered_opts);
    this.receivers_select.select2('val', this.receivers_select.val())
  }
}
